import styled from 'styled-components';
import { Modal, Button } from '@veneer/core';
import { primitives } from '@veneer/primitives';
const { color, typography, layout } = primitives;

export const StyledModal = styled(Modal)`
  && {
    width: 496px !important;
    border-radius: ${layout.cornerRadius4}px !important;
    padding: 40px 48px !important;

    @media (max-width: ${layout.breakpoint1}px) {
      max-width: calc(100vw - 32px) !important;
      width: calc(100vw - 32px) !important;
      height: auto !important;
      max-height: calc(100vh - 64px) !important;
      padding: 24px !important;
    }
  }
`;
export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalTitle = styled.div`
  font-size: ${typography.size7};
  line-height: ${typography.lineHeight7};
  font-weight: ${typography.weight4};
  color: ${color.gray12};

  @media (max-width: ${layout.breakpoint1}px) {
    font-size: ${typography.size4};
    line-height: ${typography.lineHeight4};
    font-weight: ${typography.weight4};
  }
`;

export const FirstParagraph = styled.p`
  font-size: ${typography.size2};
  line-height: ${typography.lineHeight3};
  font-weight: ${typography.weight3};
  color: ${color.gray12};

  @media (max-width: ${layout.breakpoint1}px) {
    font-size: ${typography.size1};
    line-height: ${typography.lineHeight2};
    font-weight: ${typography.weight3};
  }
`;
export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export const ProceedButton = styled(Button)`
  min-width: 112px;
  height: 48px;
  border-radius: ${layout.cornerRadius2}px;
  background-color: ${color.electricBlue7};
  font-size: ${typography.size2};
  font-weight: ${typography.weight3};
  line-height: ${typography.lineHeight2};
  width: auto;

  @media (max-width: ${layout.breakpoint1}px) {
    min-width: 112px;
    height: 36px;
    padding: 10px 16px;
    font-size: ${typography.size1};
    line-height: ${typography.lineHeight2};
  }
`;
